import { Kaggle } from "@kaggle/sdk";

import AcceleratorType = Kaggle.Sdk.Kernels.AcceleratorType;

export function acceleratorTypeToQuotaType(
  accelerator: AcceleratorType
): "gpu" | "tpu" {
  if (isTpuAccelerator(accelerator)) {
    return "tpu";
  }
  return "gpu";
}

export const isTpuAccelerator = (accelerator: AcceleratorType) => {
  return (
    accelerator === AcceleratorType.TPU_V3_8 ||
    accelerator === AcceleratorType.TPU_V2_32 ||
    accelerator === AcceleratorType.TPU_V2_256
  );
};
